/* import __COLOCATED_TEMPLATE__ from './create-invite-bulk.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();